<template>
  <el-select
    ref="elselect"
    :value="valueTitle"
    :clearable="clearable"
    @focus="focusSelect"
    @clear="clearHandle"
    :placeholder="inputName"
    filterable
    :filter-method="dataFilter"
  >
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane label="经济体" name="0" id="1">
        <el-option :value="valueTitle" :label="valueTitle" class="options">
          <el-tree
            id="tree-option"
            ref="selectTree"
            :data="optionClone"
            :props="props"
            :node-key="props.value"
            @node-click="handleNodeClick"
          >
          <!-- <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <a class="my-badge">{{data.num}}</a>
            </span>
          </span> -->
          
          </el-tree>
        </el-option>
      </el-tab-pane>
      <el-tab-pane label="地区" name="1" id="2" style="display:none">
        <el-option :value="valueTitle" :label="valueTitle" class="options">
          <el-tree
            id="tree-option1"
            ref="selectTree1"
            :show-count="true"
            :data="option1Clone"
            :props="props"
            :node-key="props.value"
            @node-click="handleNodeClick"
          ></el-tree>
        </el-option>
      </el-tab-pane>
      <el-tab-pane label="经济组织" name="2" id="3" style="display:none">
        <el-option :value="valueTitle" :label="valueTitle" class="options">
          <el-tree
            id="tree-option2"
            ref="selectTree2"
            :data="option2Clone"
            :props="props"
            :node-key="props.value"
            @node-click="handleNodeClick"
          ></el-tree>
        </el-option>
      </el-tab-pane>
      <el-tab-pane label="一带一路国家和地区" name="3" id="4" style="display:none">
        <el-option :value="valueTitle" :label="valueTitle" class="options">
          <el-tree
            id="tree-option3"
            ref="selectTree3"
            :data="option3Clone"
            :props="props"
            :node-key="props.value"
            @node-click="handleNodeClick"
          ></el-tree>
        </el-option>
      </el-tab-pane>
    </el-tabs>
  </el-select>
</template>

<script>
export default {
  name: "el-tree-select",
  props: {
    // 配置项
    inputName: String,
    required: true,
    props: {
      type: Object,
      default: {
        value: "id", // ID字段名
        label: "title", // 显示名称
        children: "children" // 子级字段名
      }
    },

    // 选项列表数据(树形结构的对象数组)
    options: { type: Array, default: [] },
    options1: { type: Array, default: [] },
    options2: { type: Array, default: [] },
    options3: { type: Array, default: [] },
    // 初始值
    value: { type: Number, default: null },
    // 可清空选项
    clearable: { type: Boolean, default: true }
    // 自动收起
    // accordion: { type: Boolean, default: false }
  },
  data() {
    return {
      // activeTab: "first",
      // selectTab: "tab-first",
      activeTab: "0",
      selectTab: "tab-0",
      optionClone: [],
      option1Clone: [],
      option2Clone: [],
      option3Clone: [],
      valueId: 0,
      valueTitle: "",
      valuelayer: false,
      tabnum: 0,
      defaultExpandedKey: []
    };
  },
  mounted() {
    // this.valueId = this.value; // 初始值
    this.optionClone = this.cloneObj(this.options);
    this.option1Clone = this.cloneObj(this.options1);
    // console.log(this.option1Clone,'this.option1Clone')
    this.option2Clone = this.cloneObj(this.options2);
    // console.log(this.option2Clone,'this.option2Clone')
    this.option3Clone = this.cloneObj(this.options3);
    // console.log(this.option3Clone,'this.option3Clone')
    this.initHandle();
  },
  methods: {
    // 初始化值
    initHandle() {
      this.initScroll();
    },
    cloneObj(obj) {
      var newObj = {};
      if (obj instanceof Array) {
        newObj = [];
      }
      for (var key in obj) {
        var val = obj[key];
        newObj[key] = typeof val === "object" ? this.cloneObj(val) : val;
      }
      return newObj;
    },
    // 初始化滚动条
    initScroll() {
      this.$nextTick(() => {
        let scrollWrap = document.querySelectorAll(
          ".el-scrollbar .el-select-dropdown__wrap"
        )[0];
        let scrollBar = document.querySelectorAll(
          ".el-scrollbar .el-scrollbar__bar"
        );
        scrollWrap.style.cssText =
          "margin: 0px; max-height: none; overflow: hidden;";
        scrollBar.forEach(ele => (ele.style.width = 0));
      });
    },
    handleClick: function(tab, event) {
      this.selectTab = event.target.getAttribute("id");
      this.tabnum = tab.name;
    },
    dataFilter(val) {
      if (val) {
        let treeData = this.cloneObj(this.options);
        this.findTreeNode1(treeData, val);
        this.optionClone = treeData;
        let treeData1 = this.cloneObj(this.options1);
        this.findTreeNode1(treeData1, val);
        this.option1Clone = treeData1;
        let treeData2 = this.cloneObj(this.options2);
        this.findTreeNode1(treeData2, val);
        this.option2Clone = treeData2;
        let treeData3 = this.cloneObj(this.options3);
        this.findTreeNode1(treeData3, val);
        this.option3Clone = treeData3;
        //搜索后如果有二级展开
        this.$refs.selectTree1.store.defaultExpandAll = true;
        this.$refs.selectTree2.store.defaultExpandAll = true;
      } else {
        this.optionClone = this.cloneObj(this.options);
        this.option1Clone = this.cloneObj(this.options1);
        this.option2Clone = this.cloneObj(this.options2);
        this.option3Clone = this.cloneObj(this.options3);
        //折叠
        this.$refs.selectTree1.store.defaultExpandAll = false;
        this.$refs.selectTree2.store.defaultExpandAll = false;
      }
    },
    findTreeNode1(arr, val) {
      for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        if (item.name.search(val) != -1) {
          continue;
        } else {
          if (item.children != undefined && item.children.length > 0) {
            this.findTreeNode1(item.children, val);
            if (item.children == undefined || item.children.length === 0) {
              arr.splice(i, 1);
              i--;
            }
          } else {
            arr.splice(i, 1);
            i--;
          }
        }
      }
    },
    panelchange(value) {},
    // 切换选项
    handleNodeClick(node) {
      //if (node.children == undefined) {//不允许选择一级
      //子节点
      // this.valuelayer = false表示没儿子
      if (node.children == undefined) this.valuelayer = false;
      else this.valuelayer = true;

      this.valueTitle = node[this.props.label];
      this.valueId = node[this.props.value];
      this.$emit(
        "getValue",
        this.valueTitle +
          "," +
          this.valueId +
          "," +
          this.tabnum +
          "," +
          this.valuelayer
      );
      this.defaultExpandedKey = [];
      this.$refs.elselect.blur();
      //}
    },
    // 清除选中
    clearHandle() {
      this.valueTitle = "";
      this.valueId = 0;
      this.defaultExpandedKey = [];
      this.clearSelected();
      this.$emit("getValue", null);
    },
    // 清空选中样式
    clearSelected() {
      let allNode = document.querySelectorAll("#tree-option .el-tree-node");
      allNode.forEach(element => element.classList.remove("is-current"));
    },
    focusSelect() {
      this.optionClone = this.cloneObj(this.options);
      this.option1Clone = this.cloneObj(this.options1);
      this.option2Clone = this.cloneObj(this.options2);
      this.option3Clone = this.cloneObj(this.options3);
      //折叠
      this.$refs.selectTree1.store.defaultExpandAll = false;
      this.$refs.selectTree2.store.defaultExpandAll = false;
    }
  },

  watch: {
    value() {
      // this.valueId = this.value;
      this.initHandle();
    },
    options() {
      this.optionClone = this.cloneObj(this.options);
      this.option1Clone = this.cloneObj(this.options1);
      // console.log(this.options1,'this.option1Clone')
      this.option2Clone = this.cloneObj(this.options2);
      this.option3Clone = this.cloneObj(this.options3);
      this.initHandle();
    }
  }
};
</script>

<style lang="less" scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 0;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
ul li /deep/ .el-tree .el-tree-node__content {
  height: auto;
  padding: 0 20px;
}
.el-tree-node__label {
  font-weight: normal;
}
.el-tree /deep/ .is-current .el-tree-node__label {
  color: #409eff;
  font-weight: 700;
}
.el-tree /deep/ .is-current .el-tree-node__children .el-tree-node__label {
  color: #606266;
  font-weight: normal;
}
/* 新增 */
/* 下拉框宽度 */
.el-select {
  width: 275px;
}
/* 下拉tab位置 */
/deep/.el-tabs__nav {
  margin-left: 25px;
  margin-right: 25px;
}
/* 下拉框小箭头 */
/deep/.el-input__icon {
  margin-top: 2px !important;
}
.el-tab-pane:nth-child(2) /deep/ .el-tree-node__content{
  padding-left: 20px!important;
}
.el-tab-pane:nth-child(3) /deep/ .el-tree-node__content{
  padding-left: 20px!important;
}
/deep/#tree-option1>.el-tree-node >.el-tree-node__content>.el-tree-node__expand-icon,
/deep/#tree-option2>.el-tree-node >.el-tree-node__content>.el-tree-node__expand-icon {
  border: 1px solid #606266;
  position: absolute;
  right: 24px;
  cursor: pointer;
  padding: 2px;
  color: #606266;
}
/deep/#tree-option1>.el-tree-node >.el-tree-node__content>.el-tree-node__expand-icon:hover,
/deep/#tree-option2>.el-tree-node >.el-tree-node__content>.el-tree-node__expand-icon:hover {
  border: 1px solid #4996dd;
  cursor: pointer;
  color: #4996dd;
}
</style>
